module.exports = "/images/whatnow_video.svg?06d2b7e7560e4ae776a6c74070748c5a";